import { Image } from 'primereact/image';
import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import Layout from "../../components/common/nav/initiator/nav.component";
import CheckArchive from '../../components/common/CheckArchive';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Auth, DataStore, SortDirection } from 'aws-amplify';
import { ValidateAllRoleExceptAdmin } from '../../helper/validateRole';
import { Column } from 'primereact/column';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import Editpopup from "../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from '../../setup/auth/login.component';
import sidebar from "../../assets/images/sidebarright.svg"
import { Dropdown } from 'primereact/dropdown';
import { FilterMatchMode, } from 'primereact/api';
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import {
    Schools,
    CertificatedSubInitiateRequest,
    CertificatedSubRequestTeacherData,
    CertificatedSubRequestTransactionCycle,
} from "../../models";
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from "moment";
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import AWS from "aws-sdk";
import awsmobile from "../../aws-exports";
import { reactLocalStorage } from 'reactjs-localstorage';
import { TabPanel, TabView } from 'primereact/tabview';
import { USER_TYPES, USER_TYPES_NAMES, SUB_CERTIFICATED_STATUS,SUBCERTIFICATED_ARCHIVE_DESIG } from "../../helper/enum";
import { useReactToPrint } from "react-to-print";
import ViewPopUp from './PopUps/ViewPopUp';
import EditPopupRequestedReport from './PopUps/EditPopupRequestedReport';
import { GetValueFromArray, graphQLGetAllData, graphQLFindRecordById } from '../../helper/commonfunctions';
import handleDateSelect from '../../helper/convertDateIntoPSTFormat';
import { handleNotificationsOnStatusChangeforSubstituteRequestCertificated } from '../../components/actions/notficationActions';
import ReportDeleteDialog from '../../components/reportSoftDelete';
import { toast } from 'react-toastify';

import CheckboxHeader from '../../components/reportArchive/CheckboxHeader';
import CheckboxColumn from '../../components/reportArchive/CheckboxColumn';


export default function SubstituteRequestCertificated() {

    const [isVisibleDelete, setIsVisibleDelete] = useState(false);
    const [isVisibleDeleteID, setIsVisibleDeleteID] = useState(null);
    const { subCer_reportId, reportIdFromAP } = useParams();
    const [reportEditByAP, setReportEditByAP] = useState(reportIdFromAP);

    const [typeOfUser, setTypeOfUser] = useState();
    const loggedUserRole = reactLocalStorage.get('loggedUserRole');

    const location = useLocation();



    useEffect(() => {
        const parts = location.pathname.split('/');
        const lastPart = parts[parts.length - 1];
        setTypeOfUser(lastPart)
        console.log('Last Part of Current Route TR:', lastPart);
        localStorage.setItem("lastPart", lastPart);
        if (subCer_reportId) {
            if (loggedUserRole === "I" && lastPart === "initiator") {
                const path =
                    `/substitute_request_certificated/${subCer_reportId}/${lastPart}`
                navigateTo(path);
                // navigateTo(0);
            }
            else if (loggedUserRole === "AP" && lastPart === "approver") {
                const path =
                    `/substitute_request_certificated/${subCer_reportId}/${lastPart}`;
                navigateTo(path);
                // navigateTo(0);
            }
            else if (loggedUserRole === "P" && lastPart === "payroll") {
                const path =
                    `/substitute_request_certificated/${subCer_reportId}/${lastPart}`;
                navigateTo(path);
                // navigateTo(0);
            }
            else {
                reactLocalStorage.clear();
                navigateTo(`/substitute_request_certificated/${subCer_reportId}/${lastPart}`);
            }
        }
        else {
            navigateTo(location.pathname);
        }

    }, [location.pathname]);




    const [showEditReportButton, setShowEditReportButton] = useState(false);

    let [isLoadData, setIsLoadData] = useState(true);
    let [loadDataReqReport, isLoadDataReqReport] = useState(true);
    let [loadDataPayrollReport, isLoadDataPayrollReport] = useState(true);
    let navigateTo = useNavigate();

    //states start
    const componentRef = useRef();
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        requestDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
        assighnmentTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
        nOfSubstitutes: { value: null, matchMode: FilterMatchMode.CONTAINS },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
    });

    const CounterAction = (row, index) => {
        return (
            (index.rowIndex) + 1
        );
    };
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedReportingManagerEmployee, setSelectedReportingManagerEmployee] = useState(null);
    const [allEmployeeDetails, setAllEmployeeDetails] = useState([]);
    const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null);
    const [empCodeList, setEmpCodeList] = useState([]);
    const [empCodeListForRM, setEmpCodeListForRM] = useState([]);
    //count and active index states
    const [activeIndex, setActiveIndex] = useState(0);



    //report list
    const [initiatorReportList, setInitiatorReportList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    
	const [selectedRowsApp, setSelectedRowsApp] = useState([]);
	const [selectedRowsPay, setSelectedRowsPay] = useState([]);

    const [approvalReportRequestList, setApprovalReportRequest] = useState([]);
    const [payrollReportRequest, setPayrollReportRequest] = useState([]);


    const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
    const [showNextPopUp, setShowNextPopUp] = useState(false);
    const [confirmVisible2, setConfirmVisible2] = useState(false);
    const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
    const [groupName, setGroupName] = useState();

    //------------

    const [isAuthenticated, userHasAuthenticated] = useState(true);
    const [viewPopUp, setViewPopup] = useState(false);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [visibleRequestedReportEdit, setVisibleRequestedReportEdit] = useState(false);
    const [specificReportDataForEdit, setSpecificReportDataForEdit] = useState([]);
    const [specificReportDataForView, setSpecificReportDataForView] = useState([]);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [requestApprovalConfirmVisible, setRequestApprovalConfirmVisible] = useState(false);
    const [visibleRight, setVisibleRight] = useState(false);
    const [activate, setActivate] = useState("");

    //footer Content code start
    const footerContent = (
        <div className='text-center'>
            <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible(false); setVisibleEdit(false) }}>Close</button>
        </div>
    );
    const footerContentForReqApproval = (
        <div className='text-center'>
            <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { BindList(); setRequestApprovalConfirmVisible(false); setVisibleRequestedReportEdit(false) }}>Close</button>
        </div>
    );
    // for remainder functionality

    const RemainderFunction = async (rowData) => {
        console.log('✌️rowData --->', rowData);
        const SubstituteCertificateRequestData = await graphQLFindRecordById("getCertificatedSubInitiateRequest", rowData.reportId)
        console.log('✌️substituteCertificateRequestResponse --->', SubstituteCertificateRequestData);
        let status = 'REMINDER_PENDING_FOR_APPROVAL'

        console.log(status)

        await handleNotificationsOnStatusChangeforSubstituteRequestCertificated(status, rowData?.reportId, "SUBSTITUTE_REQUEST_CERTIFICATED", rowData.AssignedUserId, SubstituteCertificateRequestData.submittedBy);
        setreminderDialog(false);
        toast.success("Reminder sent successfully");
    }

    const footerContentForReminder = (
        <div className="text-center">
            <div className="d-flex">
                <button
                    onClick={() => { RemainderFunction(ReminderData) }}
                    type="button"
                    className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                // id="add-family-cancel-btn"
                >
                    Yes
                </button>
                <button
                    onClick={() => { setreminderDialog(false) }}
                    type="button"
                    className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
                    id="add-family-cancel-btn"
                >
                    No
                </button>
            </div>
        </div>
    );
    //footer Content code end

    //*state
    const [reportId, setReportId] = useState('');
    const [userloggedRole, setUserRole] = useState("");
    const [schoolName, setSchoolName] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [status, setStatus] = useState('');
    const [isMasterDataLoaded, setIsMasterDataLoaded] = useState(false);
    const [isUpdateData, setIsUpdateData] = useState('');
    const [schoolList, setSchoolList] = useState([]);
    const [certificatedCycleList, setCertificatedCycleList] = useState([]);
    const [certificatedSubInitiateRequestList, setCertificatedSubInitiateRequestList] = useState([]);
    const [certificatedSubRequestTeacherDataList, setCertificatedSubRequestTeacherDataList] = useState([]);

    //*List
    const [employeeList, setEmployeeList] = useState([]);
    const [reportEmployeeList, setReportEmployeeList] = useState([]);
    const [users, SetUsersList] = useState([]);

    const loggedUserId = reactLocalStorage.get('loggedUserId');
    const [ReminderDialog, setreminderDialog] = useState(false);
    const [ReminderData, setreminderData] = useState(null);
    //status format and layout code start
    const TaskStatusSL = (product) => {

        switch (product.status) {

            case 'Completed':
                return 'success';

            case SUB_CERTIFICATED_STATUS.COMPLETED:
                return 'success';

            case 'Reviewed & resubmitted':
                return 'info';

            case 'Rejected':
                return 'danger';
            case SUB_CERTIFICATED_STATUS.REJECTED:
                return 'danger';

            case 'Pending':
                return 'warning';
            case 'REJECTED':
                return 'drouanger';
            case 'Submitted':
                return 'info';
            case 'PENDING':
                return 'warning';
            case 'Approved':
                return 'success';
            case 'Close':
                return 'success';
            case 'Approved (P)':
                return 'success';
            case 'Closed':
                return 'success';
            case 'OPEN':
                return 'info';
            default:
                return 'warning';
        }
    };
    const TaskStatusSLA = (product) => {
        // 
        return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
    };
    const requestReportStatusOptions = (product) => {

        switch (product.status) {
            case 'Rejected':
                return 'danger';

            case SUB_CERTIFICATED_STATUS.REJECTED:
                return 'danger';


            case 'Pending for Approval':
                return 'warning';
            case 'Close':
                return 'success';
            case 'Closed':
                return 'success';
            case 'SUBMITTED':
                return 'info';
            case 'Completed':
                return 'success';
            case SUB_CERTIFICATED_STATUS.COMPLETED:
                return 'success';

            default:
                return 'warning';
        }
    };

    const getLoggRole = async () => {
        const cognito = new AWS.CognitoIdentityServiceProvider();
        //get logged user role
        let adminUsers;
        if (loggedUserId) {
            try {
                adminUsers = await cognito.adminGetUser({
                    UserPoolId: awsmobile.aws_user_pools_id,
                    Username: loggedUserId,
                }).promise();
            } catch (e) {
                console.log("error-->", e)
                //
            }
        }
        let loggedUserRole = adminUsers.UserAttributes.find(attr => attr.Name === "custom:role")?.Value;
        let role = loggedUserRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : loggedUserRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : loggedUserRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I
        setUserRole(role)
    }

    const requestReportStatus = (product) => {
        return <Tag value={product.status} severity={requestReportStatusOptions(product)}></Tag>;
    };



    //status format and layout code end
    //action layout code start
    const initiateReportAction = (row) => {

        console.log("rowsss", row);
        const rowstatus = row.status === SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN ? "Pending for Approval Site Admin" : row.status
        return (
            <div className="flex justify-center w-full grid grid-cols-4 gap-5 items-center" >

                {

                    row.status === SUB_CERTIFICATED_STATUS.COMPLETED ?
                        <Link to='#' className="py-2 px-2.5" onClick={() => onClickInitiateRequestViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link>

                        : row.status === "Reviewed & resubmitted" ?
                            <Link to='#' className="py-2 px-2.5"
                                onClick={() => {
                                    navigateTo('/substitute_request_certificated/initiate_new_report/' + row.reportId + "/" + row.status); navigateTo(0)
                                }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i>



                            </Link>

                            :

                            row.status === SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN || (row.status === SUB_CERTIFICATED_STATUS.REJECTED && row.actionIcon) || row.status === SUB_CERTIFICATED_STATUS.PENDING ?
                                <Link to='#' className="py-2 px-2.5"
                                    onClick={() => {
                                        navigateTo('/substitute_request_certificated/initiate_new_report/' + row.reportId + "/" + rowstatus);
                                        navigateTo(0)
                                    }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
                                :
                                <Link to='#' className="py-2 px-2.5" onClick={() => onClickInitiateRequestViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link>

                }
                {
                    row.status != SUB_CERTIFICATED_STATUS.PENDING && row.status != SUB_CERTIFICATED_STATUS.COMPLETED ?
                        <Link
                            to="#"
                            className="py-2 px-2.5 pt-2"
                            onClick={() => {
                                setreminderDialog(true)
                                setreminderData(row)
                            }}
                        >
                            <i className="gusd-notification text-[#667085] text-[20px] xl:text-[1.250vw]"></i>
                        </Link> : <Link
                            to="#"
                            className="py-2 px-5"></Link>
                }
                {
                    row.status != SUB_CERTIFICATED_STATUS.COMPLETED ?
                        <Link
                            to="#"
                            // icon="pi pi-trash"
                            className="pi pi-trash py-2 px-2.5 pt-2 text-[#667085]"
                            onClick={() => {
                                setIsVisibleDeleteID(row.reportId);
                                setIsVisibleDelete(true)
                            }}
                        /> : <div className='py-2 px-2.5 pt-2'></div>
                }

                    <Link
                        to="#"
                        className="pi pi-copy py-2 px-2.5 pt-3 text-[#667085]"
                        onClick={() => {
                            navigateTo('/substitute_request_certificated/initiate_new_report/' + row.reportId + "/" + "copyReport"); navigateTo(0)
                            // onClickEditPopUp(row);
                            // setISCopyForm(true);
                        }}
                    /> 
            </div>
        );

    };
    const requestedReportAction = (row) => {
        return (
            <div className="flex justify-center w-full gap-2">
                {

                    (row.actionIcon) ?
                        <Link to='' className="py-2 px-2.5"
                            // onClick={() => { setVisibleRight(true); onClickPopup(row); }}
                            onClick={() =>
                                onClickRequestedReportEditPopUp(row)
                            }
                        ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
                        // <Link
                        //     // to='/substitute_request_certificated/initiate_new_report/'className="py-2 px-2.5"
                        //     onClick={() => {
                        //         navigateTo('/substitute_request_certificated/initiate_new_report/' + row.reportId + "/" + row.status);
                        //         navigateTo(0)
                        //     }}
                        // >
                        //     <i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>

                        :

                        (row.status === SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN && loggedUserId == row.firstApproverId) ?
                            <Link to='' className="py-2 px-2.5"
                                // onClick={() => { setVisibleRight(true); onClickPopup(row); }}
                                onClick={() =>
                                    onClickRequestedReportEditPopUp(row)
                                }
                            ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
                            :
                            (row.status === SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_CLERK && loggedUserId == row.secondApproverId) ?
                                <Link to='' className="py-2 px-2.5"
                                    // onClick={() => { setVisibleRight(true); onClickPopup(row); }}
                                    onClick={() =>
                                        onClickRequestedReportEditPopUp(row)
                                    }
                                ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :
                                (row.status === SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_MANAGER && loggedUserId == row.thirdApproverId) ?
                                    <Link to='' className="py-2 px-2.5"
                                        // onClick={() => { setVisibleRight(true); onClickPopup(row); }}
                                        onClick={() =>
                                            onClickRequestedReportEditPopUp(row)
                                        }
                                    ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :

                                    row.status === 'Approved' ?
                                        <Link to='' className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                                        row.status === 'Rejected' ?
                                            <Link to='' className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                                            <Link to='' className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link>
                }
            </div >
        );
    };
    const payrollReportAction = (row) => {
        return (
            <div className="flex justify-center w-full gap-2">
                {
                    row.status === SUB_CERTIFICATED_STATUS.PENDING_FOR_ACKNOWLEDGEMENT_SUB_DESK ?
                        <Link to='' className="py-2 px-2.5"
                            onClick={() =>
                                onClickRequestedReportEditPopUp(row)
                            }
                        ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
                        :
                        row.status === SUB_CERTIFICATED_STATUS.COMPLETED || row.status === SUB_CERTIFICATED_STATUS.REJECTED || row.status === SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN || row.status === SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_CLERK || row.status === SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_MANAGER ?
                            <Link to='' className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                            null
                }
            </div >
        );
    };
    //action layout code end
    const showSidebar = () => {
        setViewPopup(true);

        console.log("Pop up called")
        // Disables Background Scrolling whilst the SideDrawer/Modal is open
        if (typeof window != 'undefined' && window.document) {
            document.body.style.overflow = 'hidden';
        }
    }
    const visibleRequestedReportEditPopup = () => {
        setVisibleRequestedReportEdit(true);
        if (typeof window != 'undefined' && window.document) {
            document.body.style.overflow = 'hidden';
        }
    }
    //* onclick view popup
    const onClickInitiateRequestViewPopup = async (requestData) => {
        //start here
        const cognito = new AWS.CognitoIdentityServiceProvider();
        let approvalFinalData = [];
        try {
            // const particularReportTransactionCycleResponse = await DataStore.query(CertificatedSubRequestTransactionCycle,
            //     (c) => c.reportId.eq(requestData.reportId),
            //     { sort: s => s.createdAt(SortDirection.DESCENDING) }
            // );

            let particularReportTransactionCycleResponse = certificatedCycleList.filter(e => e.reportId.includes(requestData.reportId))
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((b, a) => a.createdAt.localeCompare(b.createdAt));

            // const certificatedSubInitiateRequestResponseForApprover = await DataStore.query(CertificatedSubInitiateRequest,
            //     (c) => c.id.eq(requestData.reportId),
            // );

            const certificatedSubInitiateRequestResponseForApprover = certificatedSubInitiateRequestList.find(o => o.id === requestData.reportId)
            console.log('particularReportTransactionCycleResponse->View', particularReportTransactionCycleResponse)

            if (particularReportTransactionCycleResponse) {
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';

                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();
                        } catch (e) {
                            console.log("error-->", e)
                            //
                        }
                    }

                    let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                    let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                    let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : ''
                    let fullName = userFirstName + " " + userLastName

                    // var certificatedSubRequestTransactionCycleResponses = await DataStore.query(CertificatedSubRequestTransactionCycle,
                    //                 (c) => c.reportId.eq(requestData.reportId),
                    //                 { sort: s => s.createdAt(SortDirection.ASCENDING) }
                    //             );


                    let statusReport = "";
                    let toEmployeeIdNewInit = particularReportTransactionCycleResponse[i].to_Employee_Id

                    if (certificatedSubInitiateRequestResponseForApprover.firstApproverId === toEmployeeIdNewInit) {
                        statusReport = 'Site Admin/Dept Head'
                    } else if (certificatedSubInitiateRequestResponseForApprover.secondApproverId === toEmployeeIdNewInit) {
                        statusReport = 'Budget Clerk'
                    } else if (certificatedSubInitiateRequestResponseForApprover.thirdApproverId === toEmployeeIdNewInit) {
                        statusReport = 'Budget Manager'
                    }
                    else {
                        statusReport = 'Acknowledgement'
                    }



                    let appDate = particularReportTransactionCycleResponse[i].customUpdatedAt ? moment(particularReportTransactionCycleResponse[i].customUpdatedAt, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A") : moment(particularReportTransactionCycleResponse[i].updatedAt, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A")

                    let obj = {
                        empName: fullName,
                        empCode: userCodeEmp,
                        updatedAt: appDate,
                        isApproved: particularReportTransactionCycleResponse[i].isApproved,
                        status: (particularReportTransactionCycleResponse[i].status == 'CLOSED' ? 'Acknowledged' : (particularReportTransactionCycleResponse[i].status == 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover.status) == 'PENDING' ? 'Pending' : statusReport)),

                        //status: (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'CLOSED' ? 'Completed' : (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover[0].status) == 'PENDING' ? 'Pending' : statusReport)),
                        //status: ((particularReportTransactionCycleResponse[i].status) === "SUBMITTED") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
                    }
                    approvalFinalData.push(obj);
                }

            }

        } catch (err) {
            console.log("error-->", err)

        }


        requestData = { ...requestData, approvalFinalData: approvalFinalData }
        //ends here

        setSpecificReportDataForView(requestData);
        // setViewPopup(true);
        showSidebar();

    }
	
	function getArchiveDesignation (currentItem) {
		let archiveDesignation = SUBCERTIFICATED_ARCHIVE_DESIG.Initiator;
		if (currentItem?.firstApproverId === loggedUserId) {
			archiveDesignation= SUBCERTIFICATED_ARCHIVE_DESIG.principalAndDepartmentHead

		} else if (currentItem?.secondApproverId === loggedUserId) {
			archiveDesignation= SUBCERTIFICATED_ARCHIVE_DESIG.budgetApprover

		} else if (currentItem?.thirdApproverId === loggedUserId) {
			archiveDesignation= SUBCERTIFICATED_ARCHIVE_DESIG.budgetManagerApprover
		}else if (currentItem?.payrollId === loggedUserId) {
			archiveDesignation= SUBCERTIFICATED_ARCHIVE_DESIG.payrollHr
		}
		return archiveDesignation;
		
	}
		
	

    //onclick requested report popups
    //onclick edit poup
    const onClickRequestedReportEditPopUp = async (requestData) => {


        // #436&#438 start.
        if (requestData?.actionIcon) {
            setShowEditReportButton(true);
        } else {
            setShowEditReportButton(false);
        }
        // #436&#438 end.

        //start here
        const cognito = new AWS.CognitoIdentityServiceProvider();
        let approvalFinalData = [];
        const certificatedSubInitiateRequestResponseForApprover = certificatedSubInitiateRequestList.find(o => o.id === requestData.reportId)
        try {
            // const particularReportTransactionCycleResponse = await DataStore.query(CertificatedSubRequestTransactionCycle,
            //     (c) => c.reportId.eq(requestData.reportId),
            //     { sort: s => s.createdAt(SortDirection.DESCENDING) }
            // );

            let particularReportTransactionCycleResponse = certificatedCycleList.filter(e => e.reportId.includes(requestData.reportId))
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((b, a) => a.createdAt.localeCompare(b.createdAt));

            // const certificatedSubInitiateRequestResponseForApprover = await DataStore.query(CertificatedSubInitiateRequest,
            //     (c) => c.id.eq(requestData.reportId),
            // );

            if (particularReportTransactionCycleResponse) {
                let currentDateTime = moment();
                currentDateTime = moment(currentDateTime).format("YYYY-MM-DD HH:mm:ss");
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';



                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();
                        } catch (e) {
                            console.log("error-->", e)
                            //
                        }
                    }



                    let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                    let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                    let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : ''
                    let fullName = userFirstName + " " + userLastName

                    // var certificatedSubRequestTransactionCycleResponses = await DataStore.query(CertificatedSubRequestTransactionCycle,
                    //                 (c) => c.reportId.eq(requestData.reportId),
                    //                 { sort: s => s.createdAt(SortDirection.ASCENDING) }
                    //             );


                    let statusReport = "";
                    let toEmployeeIdNewInit = particularReportTransactionCycleResponse[i].to_Employee_Id

                    if (certificatedSubInitiateRequestResponseForApprover.firstApproverId === toEmployeeIdNewInit) {
                        statusReport = 'Site Admin/Dept Head'
                    } else if (certificatedSubInitiateRequestResponseForApprover.secondApproverId === toEmployeeIdNewInit) {
                        statusReport = 'Budget Clerk'
                    } else if (certificatedSubInitiateRequestResponseForApprover.thirdApproverId === toEmployeeIdNewInit) {
                        statusReport = 'Budget Manager'
                    }
                    else if (certificatedSubInitiateRequestResponseForApprover?.payrollId == toEmployeeIdNewInit) {
                        statusReport = 'Sub Desk';
                    } else {
                        statusReport = 'Acknowledgement'
                    }

                    let appDate = (particularReportTransactionCycleResponse[i].customUpdatedAt) ? handleDateSelect(particularReportTransactionCycleResponse[i].customUpdatedAt) : handleDateSelect(currentDateTime)

                    let obj = {
                        empName: fullName,
                        empCode: userCodeEmp,
                        updatedAt: appDate,
                        isApproved: particularReportTransactionCycleResponse[i].isApproved,
                        status: (particularReportTransactionCycleResponse[i].status == 'CLOSED' ? 'Acknowledged' : (particularReportTransactionCycleResponse[i].status == 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover.status) == 'PENDING' ? 'Pending' : particularReportTransactionCycleResponse[i].status))
                        //status: (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'CLOSED' ? 'Completed' : (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover[0].status) == 'PENDING' ? 'Pending' : statusReport)),
                        //status: ((particularReportTransactionCycleResponse[i].status) === "SUBMITTED") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
                    }
                    approvalFinalData.push(obj);
                }

            }

        } catch (err) {
            console.log("error-->", err)

        }
        console.log('hhih')
        requestData = { ...requestData, approvalFinalData: approvalFinalData, createdDate: certificatedSubInitiateRequestResponseForApprover.createdAt }
        //ends here
        setSpecificReportDataForEdit(requestData);
        // setVisibleRequestedReportEdit(true);
        visibleRequestedReportEditPopup();
    }
    //* onclick view popup
    const onClickRequestedReportViewPopup = async (requestData) => {

        //start here
        const cognito = new AWS.CognitoIdentityServiceProvider();
        let approvalFinalData = [];
        try {
            // const particularReportTransactionCycleResponse = await DataStore.query(CertificatedSubRequestTransactionCycle,
            //     (c) => c.reportId.eq(requestData.reportId),
            //     { sort: s => s.createdAt(SortDirection.DESCENDING) }
            // );

            let particularReportTransactionCycleResponse = certificatedCycleList.filter(e => e.reportId.includes(requestData.reportId))
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((b, a) => a.createdAt.localeCompare(b.createdAt));

            // const certificatedSubInitiateRequestResponseForApprover = await DataStore.query(CertificatedSubInitiateRequest,
            //     (c) => c.id.eq(requestData.reportId),
            // );
            const certificatedSubInitiateRequestResponseForApprover = certificatedSubInitiateRequestList.find(o => o.id === requestData.reportId)

            if (particularReportTransactionCycleResponse) {
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';

                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();
                        } catch (e) {
                            console.log("error-->", e)
                            //
                        }
                    }

                    let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                    let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                    let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : ''
                    let fullName = userFirstName + " " + userLastName

                    // var certificatedSubRequestTransactionCycleResponses = await DataStore.query(CertificatedSubRequestTransactionCycle,
                    //     (c) => c.reportId.eq(requestData.reportId),
                    //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
                    // );

                    let certificatedSubRequestTransactionCycleResponses = certificatedCycleList.filter(e => e.reportId.includes(requestData.reportId))
                    certificatedSubRequestTransactionCycleResponses = certificatedSubRequestTransactionCycleResponses.sort((b, a) => a.createdAt.localeCompare(b.createdAt));


                    let statusReport = "";
                    let toEmployeeIdNewInit = particularReportTransactionCycleResponse[i].to_Employee_Id
                    console.log('particularReportTransactionCycleResponse->certificatedSubInitiateRequestResponseForApprover', certificatedSubInitiateRequestResponseForApprover)
                    console.log('particularReportTransactionCycleResponse', particularReportTransactionCycleResponse)


                    if (certificatedSubInitiateRequestResponseForApprover.firstApproverId === toEmployeeIdNewInit) {
                        statusReport = 'Site Admin/Dept Head'
                    } else if (certificatedSubInitiateRequestResponseForApprover.secondApproverId === toEmployeeIdNewInit) {
                        statusReport = 'Budget Clerk'
                    } else if (certificatedSubInitiateRequestResponseForApprover.thirdApproverId === toEmployeeIdNewInit) {
                        statusReport = 'Budget Manager'
                    }
                    else if (certificatedSubInitiateRequestResponseForApprover.status === "PENDING") {
                        statusReport = 'Pending'
                    }
                    else if (certificatedSubInitiateRequestResponseForApprover.status === "REJECTED") {
                        statusReport = 'Rejected'
                    }
                    else {
                        statusReport = 'Acknowledgement'
                    }



                    let appDate = particularReportTransactionCycleResponse[i].customUpdatedAt ? moment(particularReportTransactionCycleResponse[i].customUpdatedAt, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A") : moment(particularReportTransactionCycleResponse[i].updatedAt, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A")

                    let obj = {
                        empName: fullName,
                        empCode: userCodeEmp,
                        updatedAt: appDate,
                        isApproved: particularReportTransactionCycleResponse[i].isApproved,
                        // status: (particularReportTransactionCycleResponse[i].status == 'CLOSED' ? 'Acknowledged' : (particularReportTransactionCycleResponse[i].status == 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover.status) == 'PENDING' ? 'Pending' : statusReport))
                        status: (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'CLOSED' ? 'Completed' : (certificatedSubRequestTransactionCycleResponses.status === 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover.status) == 'PENDING' ? 'Pending' : statusReport)),
                        //status: ((particularReportTransactionCycleResponse[i].status) === "SUBMITTED") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
                    }
                    approvalFinalData.push(obj);
                }

            }

        } catch (err) {
            console.log("error-->", err)

        }


        requestData = { ...requestData, approvalFinalData: approvalFinalData }
        //ends here

        setSpecificReportDataForView(requestData);
        // setViewPopup(true);
        showSidebar();

    }

    const toggleActive = () => {
        setActivate(activate === "actives" ? "" : "actives");
    };

    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidateAllRoleExceptAdmin()) { userHasAuthenticated(false); }
        } catch (e) {
            console.log("error-->", e)
            userHasAuthenticated(false);
        }
    }


    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });

    const loadUsers = () => {
        //------------------------------- load users-------------
        const cognito = new AWS.CognitoIdentityServiceProvider();
        var params =
        {
            UserPoolId: awsmobile.aws_user_pools_id,
            Limit: 60
        };
        cognito.listUsers(params, (err, data) => {
            if (err) {

            } else {
                // 
                SetUsersList(data.Users);



                var newRes = []
                let userRole = '', userName = '', userEmail = '', userCode = '', sub = '';
                (data.Users).forEach((user, i) => {
                    userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
                    userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
                    sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
                    userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
                    userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;

                    let obj = {
                        "userId": sub,
                        "name": userName,
                        "email": userEmail,
                        "usercode": userCode,
                        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
                    }
                    newRes.push(obj);
                }
                );


                //get only those users are without admin
                let usersWithoutAdminAndLoggedUser = [];
                const loggedUserId = reactLocalStorage.get('loggedUserId');


                newRes.map((currentItem) => {
                    if (currentItem.role !== 'Admin'
                        && currentItem.userId !== loggedUserId) {
                        usersWithoutAdminAndLoggedUser.push(currentItem);
                    }
                })

                //set employee list
                let finalEmployeeList = [{ name: "No Approval Needed", code: 'no_approval_needed' }];

                usersWithoutAdminAndLoggedUser.map((currentItem) => {
                    let obj = { name: currentItem.name, code: currentItem.userId };
                    finalEmployeeList.push(obj);
                })
                setEmployeeList(finalEmployeeList);
                getLoggRole();


            }
        });
        //-------------------------------------------------------
    }

    const BindList = async () => {


        const loggedUserId = reactLocalStorage.get('loggedUserId');


        try {
            //1)Initiator Side Reports
            if (certificatedSubReqIsInitiator == 1) {
                // const certificatedSubInitiateRequestResponse = await DataStore.query(CertificatedSubInitiateRequest,
                //     (c) => c.submittedBy.eq(loggedUserId),
                //     { sort: s => s.updatedAt(SortDirection.ASCENDING) }
                // );

                let certificatedSubInitiateRequestResponse = certificatedSubInitiateRequestList.filter(e => e.submittedBy.includes(loggedUserId) && e.isSoftDelete !== true )

                certificatedSubInitiateRequestResponse = certificatedSubInitiateRequestResponse.sort((a, b) => a.updatedAt.localeCompare(b.updatedAt));


                let finalInitiateRequestData = [];
                if (certificatedSubInitiateRequestResponse) {
                    let sn = certificatedSubInitiateRequestResponse.length;
					outerLoop:
                    for (let i = 0; i < certificatedSubInitiateRequestResponse.length; i++) {

                        let currentItem = certificatedSubInitiateRequestResponse[i]


                        //get school name from its id.
                        // var SchoolResponses = await DataStore.query(Schools, (c) => c.id.eq(currentItem.schoolOrDeptId));
                        var SchoolResponses = schoolList.find(o => o.id === currentItem.schoolOrDeptId)

                        //get number of substitute from CertificatedSubRequestTeacherData table
                        // var certificatedSubRequestTeacherDataResponses = await DataStore.query(CertificatedSubRequestTeacherData, (c) => c.reportId.eq(currentItem.id));

                        var certificatedSubRequestTeacherDataResponses = certificatedSubRequestTeacherDataList.filter(e => e.reportId.includes(currentItem.id))

                        //get particular report id transaction table records
                        // var certificatedSubRequestTransactionCycleResponses = await DataStore.query(CertificatedSubRequestTransactionCycle,
                        //     (c) => c.reportId.eq(currentItem.id),
                        //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
                        // );

                        let certificatedSubRequestTransactionCycleResponses = certificatedCycleList.filter(e => e.reportId.includes(currentItem.id))


                        certificatedSubRequestTransactionCycleResponses = certificatedSubRequestTransactionCycleResponses.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

                        //console.log(certificatedSubRequestTransactionCycleResponses.length,"certificatedSubRequestTransactionCycleResponses")

						 if (SchoolResponses && certificatedSubRequestTeacherDataResponses) {

                            let filterRemark = certificatedSubRequestTransactionCycleResponses;
                            //filterRemark = filterRemark.sort((a, b) => b.createdAt.localeCompare(a.createdAt));
                            filterRemark = [...filterRemark].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                            const latestRemark = filterRemark.filter(obj => (obj.remark !== null));

                            let cycleLength = certificatedSubRequestTransactionCycleResponses.length;
                            let rejectEditIcon;
                            let statusReport = "";
                            if (certificatedSubRequestTransactionCycleResponses.length) {
                                let toEmployeeIdNewInit = certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].to_Employee_Id

                                if (certificatedSubRequestTransactionCycleResponses[0]) {

                                    if (currentItem?.firstApproverId === toEmployeeIdNewInit) {

                                        if(certificatedSubRequestTransactionCycleResponses[cycleLength-1]?.approver_level){
                                            statusReport = 'Rejected'
                                            rejectEditIcon=true;
                                        }else{
                                        statusReport = SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN
										}

                                        if (certificatedSubRequestTransactionCycleResponses[cycleLength - 1]?.approver_level === 'site/dept') {
                                            statusReport = 'Rejected'
                                            rejectEditIcon = false;
                                        }

                                    } else if (currentItem?.secondApproverId === toEmployeeIdNewInit) {
                                        statusReport = SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_CLERK
										 
                                        if (certificatedSubRequestTransactionCycleResponses[cycleLength - 1]?.approver_level === 'budgetClerk') {
                                            statusReport = 'Rejected'
                                            rejectEditIcon = false;
                                        }

                                    } else if (currentItem?.thirdApproverId === toEmployeeIdNewInit) {
                                        statusReport = SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_MANAGER
						
                                        if (certificatedSubRequestTransactionCycleResponses[cycleLength - 1]?.approver_level === 'budgetManager') {
                                            statusReport = 'Rejected'
                                            rejectEditIcon = false;
                                        }
                                    }
                                    else if (currentItem.status === "PENDING") {
                                        statusReport = SUB_CERTIFICATED_STATUS.PENDING //'Pending'
                                    }
                                    else {
                                        statusReport = SUB_CERTIFICATED_STATUS.PENDING_FOR_ACKNOWLEDGEMENT_SUB_DESK //'Pending for Acknowledgement'
                                        if (certificatedSubRequestTransactionCycleResponses[cycleLength - 1]?.approver_level === 'Initiator') {
                                            statusReport = SUB_CERTIFICATED_STATUS.REJECTED;
                                            rejectEditIcon = true;
                                        }
                                    }
                                }
                            }
					let archiveDesignation= getArchiveDesignation(currentItem);
                       		
				
					console.log("isArchivedUsers id1 :-",currentItem.id);
					console.log("isArchivedUsers name1 :-",currentItem.assighmentTitle);
                   
				if (currentItem?.isArchivedUsers) {
                    const archieveData=JSON.parse(currentItem?.isArchivedUsers);
                    console.log("isArchivedUsers:-",archieveData);
					console.log("isArchivedUsers id :-",currentItem.id);
					console.log("isArchivedUsers name :-",currentItem.assighmentTitle);
                    //console.log("substituteCertificateRequestResponse?.isArchivedUsers 0:-",typeof archieveData);
					let isArchive = CheckArchive(archieveData, archiveDesignation, loggedUserId);
                   console.log("isArchivedUsers boolean :-",isArchive);
				   if(isArchive){
						continue outerLoop;
					}
					
                }


                            let adminUsers;
                            let Assignee = "";
                            let AssignedUserId = "";
                            if (certificatedSubRequestTransactionCycleResponses.length) {
                                const cognito = new AWS.CognitoIdentityServiceProvider();

                                try {
                                    adminUsers = await cognito.adminGetUser({
                                        UserPoolId: awsmobile.aws_user_pools_id,
                                        Username: (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'REJECTED' ? loggedUserId : certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].to_Employee_Id)
                                    }).promise();
                                } catch (e) {
                                    //console.log(e)
                                }

                                let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                                let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                                Assignee = userFirstName + " " + userLastName
                                AssignedUserId = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "sub") : ''

                            }


                            let initiatorUsers;
                            let initiatorFullName;
                            if (certificatedSubRequestTransactionCycleResponses.length) {

                                const cognito = new AWS.CognitoIdentityServiceProvider();
                                try {
                                    //get initiator's data using its id
                                    initiatorUsers = await cognito.adminGetUser({
                                        UserPoolId: awsmobile.aws_user_pools_id,
                                        // Username: (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].from_Employee_Id)
                                        Username: currentItem.submittedBy
                                    }).promise();
                                } catch (e) {
                                    //console.log(e)
                                }

                                let userFirstName1 = initiatorUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
                                let userLastName1 = initiatorUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
                                initiatorFullName = userFirstName1 + " " + userLastName1;

                            }


                            let reportStatus = SUB_CERTIFICATED_STATUS.PENDING //'Pending'
                            if (certificatedSubRequestTransactionCycleResponses.length) {
                                reportStatus = (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'CLOSED' ? SUB_CERTIFICATED_STATUS.COMPLETED : (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'REJECTED' ? SUB_CERTIFICATED_STATUS.REJECTED : (currentItem.status) == 'PENDING' ? SUB_CERTIFICATED_STATUS.PENDING : statusReport))
                            }
                            let obj = {
                                id: currentItem.id,
								archiveDesignation:archiveDesignation,
                                actionIcon: rejectEditIcon,
                                reportId: currentItem.id,
                                srNo: sn,
                                requestDate: moment(currentItem.reportDate).format('MM/DD/YYYY'),
                                schoolOrDeptName: SchoolResponses.name,
                                assighnmentTitle: currentItem.assighmentTitle ? currentItem.assighmentTitle : "-",
                                createdAt: currentItem.createdAt === null ? new Date().toString() : currentItem.createdAt,
                                nOfSubstitutes: certificatedSubRequestTeacherDataResponses.length,
                                status: reportStatus,
                                submittedBy: initiatorFullName,
                                AssignedUserId: AssignedUserId ? AssignedUserId : "-",
                                Assignee:
                                    reportStatus === 'Completed' ||
                                        reportStatus === 'Pending'
                                        ?
                                        "-" :
                                        Assignee,
                                remark: ((latestRemark.length) > 0) ? latestRemark[0].remark : '-'
                            }
                            sn = sn - 1
                            finalInitiateRequestData.push(obj);
                        }
                    }

                    finalInitiateRequestData.reverse();
                    setInitiatorReportList(finalInitiateRequestData);
                    if (subCer_reportId) {

                        // Check if tr_ReportId matches any id in the array
                        const isMatch = finalInitiateRequestData.filter((data) => data.reportId === subCer_reportId);
                        console.log("isMatch", isMatch)
                        if (isMatch && isMatch[0]?.status === "Rejected") {
                            navigateTo("/substitute_request_certificated/initiate_new_report/" + isMatch[0]?.id);
                        }
                        else if (isMatch && isMatch[0]?.status === "Completed" && loggedUserRole === "I") {
                            onClickInitiateRequestViewPopup(isMatch[0], 'right')
                        }
                        else {
                            console.log("err");
                        };
                    }
                    setIsLoadData(false);

                }


                // const sortedData = [...finalInitiateRequestData].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                // console.log(sortedData)

                // 

            }

            //2)Approver Side Reports
            if (certificatedSubReqIsApprover == 1) {

                // const certificatedSubRequestTransactionCycleResponse = await DataStore.query(CertificatedSubRequestTransactionCycle,
                //     (c) => c.to_Employee_Id.eq(loggedUserId),
                //     { sort: s => s.createdAt(SortDirection.ASCENDING) }   //DESCENDING
                // );


                let certificatedSubRequestTransactionCycleResponse = certificatedCycleList.filter(e => e.to_Employee_Id && e.to_Employee_Id.includes(loggedUserId))
                certificatedSubRequestTransactionCycleResponse = certificatedSubRequestTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

                //get unique records of same report Id.
                const distinctReportIds = Object.values(certificatedSubRequestTransactionCycleResponse.reduce((acc, entry) => {
                    if (!acc[entry.reportId]) {
                        acc[entry.reportId] = entry;
                    }
                    return acc;
                }, {}));

                let finalRequestedRequestData = [];

                console.log("distinctReportIdsdistinctReportIds:-",distinctReportIds);

                if (distinctReportIds.length > 0) {
                    let sn2 = distinctReportIds.length;
					outerLoop:
                    for (let i = 0; i < distinctReportIds.length; i++) {

                        let currentItem1 = distinctReportIds[i];

                        if (currentItem1?.approver_level != "Initiator") {

                            // const certificatedSubInitiateRequestResponseForApprover = await DataStore.query(CertificatedSubInitiateRequest,
                            //     (c) => c.id.eq(currentItem1.reportId),
                            // );

                            // const certificatedSubInitiateRequestResponseForApprover = certificatedSubInitiateRequestList.find(o => o.id === currentItem1.reportId)
                            const certificatedSubInitiateRequestResponseForApprover = certificatedSubInitiateRequestList.find(o => o.id === currentItem1.reportId && o.isSoftDelete !== true);

                            //-----status handing start
                            // var certificatedSubRequestTransactionCycleResponsesForReport = await DataStore.query(CertificatedSubRequestTransactionCycle,
                            //     (c) => c.reportId.eq(currentItem1.reportId),
                            //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
                            // );

                            var certificatedSubRequestTransactionCycleResponsesForReport = certificatedCycleList.filter(e => e.reportId.includes(currentItem1.reportId))
                            certificatedSubRequestTransactionCycleResponsesForReport = certificatedSubRequestTransactionCycleResponsesForReport.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
                            //added for latest remark 
                            let filterRemark = certificatedSubRequestTransactionCycleResponsesForReport;
                            filterRemark = [...filterRemark].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                            const latestRemarks = filterRemark.filter(obj => (obj.remark != null));

                            let cycleLength = certificatedSubRequestTransactionCycleResponsesForReport.length;
                            let statusReport = "";
                            let toEmployeeIdNew = certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].to_Employee_Id

                            let approverLevel = certificatedSubRequestTransactionCycleResponsesForReport[cycleLength - 1].approver_level;

                            if (certificatedSubRequestTransactionCycleResponsesForReport[0].to_Employee_Id && certificatedSubRequestTransactionCycleResponsesForReport) {

                                if(cycleLength > 1)
                                if (certificatedSubInitiateRequestResponseForApprover?.submittedBy === toEmployeeIdNew) {
                                    statusReport = "Rejected";
                                }

                                // else 
                                if (certificatedSubInitiateRequestResponseForApprover?.firstApproverId === toEmployeeIdNew) {
                                    
                                    if(!certificatedSubRequestTransactionCycleResponsesForReport[cycleLength-1]?.approver_level){
                                    statusReport = SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN
                                    }

                                    if (certificatedSubRequestTransactionCycleResponsesForReport[cycleLength - 1]?.approver_level == 'site/dept') {
                                        statusReport = 'Rejected';
                                    }

                                } else if (certificatedSubInitiateRequestResponseForApprover?.secondApproverId === toEmployeeIdNew) {
                                    statusReport = SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_CLERK


                                    if (certificatedSubRequestTransactionCycleResponsesForReport[cycleLength - 1]?.approver_level == 'budgetClerk') {
                                        statusReport = 'Rejected';
                                    }

                                } else if (certificatedSubInitiateRequestResponseForApprover?.thirdApproverId === toEmployeeIdNew) {
                                    statusReport = SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_MANAGER

                                    if (certificatedSubRequestTransactionCycleResponsesForReport[cycleLength - 1]?.approver_level == 'budgetManager') {
                                        statusReport = 'Rejected';
                                    }

                                } else if (certificatedSubInitiateRequestResponseForApprover?.payrollId == toEmployeeIdNew) {
                                    statusReport = SUB_CERTIFICATED_STATUS.PENDING_FOR_ACKNOWLEDGEMENT_SUB_DESK //'Sub Desk';
                                
								} else {
									
                                    statusReport = SUB_CERTIFICATED_STATUS.PENDING_FOR_ACKNOWLEDGEMENT_SUB_DESK //'Pending for Acknowledgement'
                                    if (approverLevel == 'budgetManager' || approverLevel == 'budgetClerk' || approverLevel=="Initiator") {
                                        statusReport = 'Rejected';
                                    }
                                }

                            }
							
							let archiveDesignation = getArchiveDesignation(certificatedSubInitiateRequestResponseForApprover)
					
							if (certificatedSubInitiateRequestResponseForApprover?.isArchivedUsers) {
									const archieveData=JSON.parse(certificatedSubInitiateRequestResponseForApprover?.isArchivedUsers);
									//console.log("substituteCertificateRequestResponse?.isArchivedUsers:-",archieveData);
									//console.log("substituteCertificateRequestResponse?.isArchivedUsers 0:-",typeof archieveData);
									let isArchive = CheckArchive(archieveData, archiveDesignation, loggedUserId);
									if(isArchive){
										continue outerLoop;
									}
									
								}

                            let adminUsers;
                            let Assignee = "";
                            if (certificatedSubRequestTransactionCycleResponsesForReport.length) {
                                const cognito = new AWS.CognitoIdentityServiceProvider();

                                try {
                                    adminUsers = await cognito.adminGetUser({
                                        UserPoolId: awsmobile.aws_user_pools_id,
                                        Username: (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].status == 'REJECTED' ? certificatedSubInitiateRequestResponseForApprover.submittedBy : toEmployeeIdNew)
                                    }).promise();
                                } catch (e) {
                                    //console.log(e)
                                }

                                let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                                let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                                Assignee = userFirstName + " " + userLastName
                            }

                            //-----status handing end
                            //get school name from its id.
                            let certificatedSubInitiateRequestResponseForApproverData = certificatedSubInitiateRequestResponseForApprover ? certificatedSubInitiateRequestResponseForApprover : ''
                            // var SchoolResponses1 = await DataStore.query(Schools, (c) => c.id.eq(certificatedSubInitiateRequestResponseForApproverData.schoolOrDeptId));
                            var SchoolResponses1 = schoolList.find(o => o.id === certificatedSubInitiateRequestResponseForApproverData.schoolOrDeptId)

                            //ge number of substitute from CertificatedSubRequestTeacherData table
                            // var certificatedSubRequestTeacherDataResponses1 = await DataStore.query(CertificatedSubRequestTeacherData, (c) => c.reportId.eq(certificatedSubInitiateRequestResponseForApproverData.id));

                            var certificatedSubRequestTeacherDataResponses1 = certificatedSubRequestTeacherDataList.filter(e => e.reportId.includes(certificatedSubInitiateRequestResponseForApproverData.id))

                            let reportStatus = SUB_CERTIFICATED_STATUS.PENDING //'Pending'
                            if (certificatedSubRequestTransactionCycleResponsesForReport.length) {
                                reportStatus = (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].status == 'CLOSED' ? SUB_CERTIFICATED_STATUS.COMPLETED : (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].status == 'REJECTED' ? SUB_CERTIFICATED_STATUS.REJECTED : statusReport))
                            }

                            let rejectEditIcon = (reportStatus == 'Rejected'
                                && toEmployeeIdNew == loggedUserId) ? 
                                (certificatedSubRequestTransactionCycleResponsesForReport[cycleLength-1]?.approver_level!=="Initiator")?
                                true : false:false;
								


                            if (SchoolResponses1 && certificatedSubRequestTeacherDataResponses1 && certificatedSubInitiateRequestResponseForApproverData) {
                                let obj = {
                                    actionIcon: rejectEditIcon,
									id:certificatedSubInitiateRequestResponseForApprover.id,
                                    reportId: certificatedSubInitiateRequestResponseForApprover.id,
                                    srNo: sn2,
									archiveDesignation:archiveDesignation,
                                    requestDate: moment(certificatedSubInitiateRequestResponseForApprover.reportDate).format('MM/DD/YYYY'),
                                    assighnmentTitle: certificatedSubInitiateRequestResponseForApprover.assighmentTitle ? certificatedSubInitiateRequestResponseForApprover.assighmentTitle : "-",
                                    schoolOrDeptName: SchoolResponses1?.name,
                                    nOfSubstitutes: certificatedSubRequestTeacherDataResponses1.length,
                                    status: reportStatus,
                                    remark: ((latestRemarks.length) > 0) ? latestRemarks[0].remark : '-',
                                    purpose: certificatedSubInitiateRequestResponseForApprover.purposeOfReport,
                                    submittedBy: certificatedSubInitiateRequestResponseForApprover.submittedBy,
                                    firstApproverId: certificatedSubInitiateRequestResponseForApprover.firstApproverId,
                                    secondApproverId: certificatedSubInitiateRequestResponseForApprover.secondApproverId,
                                    thirdApproverId: certificatedSubInitiateRequestResponseForApprover.thirdApproverId,
                                    Assignee: reportStatus === 'Completed'
                                        ?
                                        "-" :
                                        Assignee,
                                    createdAt: certificatedSubInitiateRequestResponseForApprover.createdAt === null ? new Date().toString() : certificatedSubInitiateRequestResponseForApprover.createdAt,
                                }

                                finalRequestedRequestData.push(obj);
                            }

                            sn2 = sn2 - 1

                        }
                    }

                    finalRequestedRequestData.reverse();
                    setApprovalReportRequest(finalRequestedRequestData);
                    if (subCer_reportId) {

                        const isMatch = finalRequestedRequestData.filter((data) => data.reportId === subCer_reportId);
                        console.log("isMatch", isMatch)

                        if (isMatch[0]?.status === "Pending for Approval Site Admin/Dept Head" && loggedUserId === isMatch[0].firstApproverId
                            || isMatch[0]?.status === "Pending for Approval Budget Clerk" && loggedUserId === isMatch[0].secondApproverId
                            || isMatch[0]?.status === "Pending for Approval Budget Manager" && loggedUserId === isMatch[0].thirdApproverId
                            || isMatch[0]?.status === "Rejected" && loggedUserId !== isMatch[0].submittedBy
                        ) {
                            onClickRequestedReportEditPopUp(isMatch[0])
                            // setSpecificReportDataForEdit(isMatch[0])
                        }
                    }

                    //-------------------------
                    if (reportEditByAP) {

                        const particularData = finalRequestedRequestData.filter((data) => data.reportId === reportIdFromAP);          
                        onClickRequestedReportEditPopUp(particularData[0])
                        setReportEditByAP(null);
                    }
                    //-------------------------

                    isLoadDataReqReport(false);
                } else {
                    isLoadDataReqReport(false);
                }


            }

            //2)Payroll Side Reports
            if (certificatedSubReqIsPayroll == 1) {
                // const certificatedSubRequestTransactionCycleResponse = await DataStore.query(CertificatedSubRequestTransactionCycle,
                //     (c) => c.to_Employee_Id.eq(loggedUserId),
                //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
                // );

                let certificatedSubRequestTransactionCycleResponse = certificatedCycleList.filter(e => e.to_Employee_Id && e.to_Employee_Id.includes(loggedUserId))



                certificatedSubRequestTransactionCycleResponse = certificatedSubRequestTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
                //get unique records of same report Id.
                const distinctReportIds = Object.values(certificatedSubRequestTransactionCycleResponse.reduce((acc, entry) => {
                    if (!acc[entry.reportId]) {
                        acc[entry.reportId] = entry;
                    }
                    return acc;
                }, {}));

                let finalRequestedRequestData = [];
                if (certificatedSubRequestTransactionCycleResponse) {
                    let sn1 = distinctReportIds.length;
					outerLoop:
                    for (let i = 0; i < distinctReportIds.length; i++) {

                        let currentItem1 = distinctReportIds[i];

                        // const certificatedSubInitiateRequestResponseForApprover = await DataStore.query(CertificatedSubInitiateRequest,
                        //     (c) => c.id.eq(currentItem1.reportId),
                        // );

                        const certificatedSubInitiateRequestResponseForApprover = certificatedSubInitiateRequestList.find(o => o.id === currentItem1.reportId && o.isSoftDelete !== true)

                        // var certificatedSubRequestTransactionCycleResponsesForReport = await DataStore.query(CertificatedSubRequestTransactionCycle,
                        //     (c) => c.reportId.eq(currentItem1.reportId),
                        //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
                        // );

                        var certificatedSubRequestTransactionCycleResponsesForReport = certificatedCycleList.filter(e => e.reportId.includes(currentItem1.reportId))
                        certificatedSubRequestTransactionCycleResponsesForReport = certificatedSubRequestTransactionCycleResponsesForReport.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

                        let payrollStats = certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].status;

                        // let payrollRemark = certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].remark;

                        // #436 & #438 start
                        let payrollRemark = '';
                        certificatedSubRequestTransactionCycleResponsesForReport.map((obj) => {
                            if (obj.remark) {
                                payrollRemark = obj.remark;
                            }
                        })
                        // #436 & #438 end

                        let Assignee = "";
                        let adminUsers = "";
                        if (certificatedSubRequestTransactionCycleResponsesForReport.length) {
                            const cognito = new AWS.CognitoIdentityServiceProvider();

                            try {
                                adminUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].status == 'REJECTED' ? certificatedSubInitiateRequestResponseForApprover.submittedBy : certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].to_Employee_Id)
                                }).promise();
                            } catch (e) {
                                //console.log(e)
                            }

                            let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                            Assignee = userFirstName + " " + userLastName
                        }

                        let initiatorUsers;
                        let initiatorFullName;
                        if (certificatedSubRequestTransactionCycleResponsesForReport.length) {

                            const cognito = new AWS.CognitoIdentityServiceProvider();
                            try {
                                //get initiator's data using its id
                                initiatorUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    // Username: (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].from_Employee_Id)
                                    Username: certificatedSubInitiateRequestResponseForApprover.submittedBy
                                }).promise();
                            } catch (e) {
                                //console.log(e)
                            }

                            let userFirstName1 = initiatorUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName1 = initiatorUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
                            initiatorFullName = userFirstName1 + " " + userLastName1;

                        }

                        let reportStatus = SUB_CERTIFICATED_STATUS.PENDING //'Pending'
                        let statusRep = '';
						
                        if (certificatedSubRequestTransactionCycleResponsesForReport.length) {
                            //reportStatus = (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].status == 'CLOSED' ? SUB_CERTIFICATED_STATUS.COMPLETED : (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].status == 'REJECTED' ? SUB_CERTIFICATED_STATUS.REJECTED : (payrollStats) == 'PENDING' ? SUB_CERTIFICATED_STATUS.PENDING : payrollStats === 'OPEN' ? SUB_CERTIFICATED_STATUS.PENDING_FOR_ACKNOWLEDGEMENT_SUB_DESK : payrollStats === 'Reviewed & resubmitted' ? SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN : payrollStats))
                            let toEmployeeIdNew = certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].to_Employee_Id
                            if (certificatedSubRequestTransactionCycleResponsesForReport[0].to_Employee_Id && certificatedSubRequestTransactionCycleResponsesForReport) {

                                if (certificatedSubInitiateRequestResponseForApprover?.submittedBy === toEmployeeIdNew) {
                                    statusRep = "Rejected";
                                }

                                else if (certificatedSubInitiateRequestResponseForApprover?.firstApproverId === toEmployeeIdNew) {
                                    statusRep = SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN

                                    if (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1]?.approver_level == 'site/dept') {
                                        statusRep = 'Rejected';
                                    }

                                } else if (certificatedSubInitiateRequestResponseForApprover?.secondApproverId === toEmployeeIdNew) {
                                    statusRep = SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_CLERK

                                    if (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1]?.approver_level == 'budgetClerk') {
                                        statusRep = 'Rejected';
                                    }

                                } else if (certificatedSubInitiateRequestResponseForApprover?.thirdApproverId === toEmployeeIdNew) {
                                    statusRep = SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_MANAGER

                                    if (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1]?.approver_level == 'budgetManager') {
                                        statusRep = 'Rejected';
                                    }

                                } else if (certificatedSubInitiateRequestResponseForApprover?.payrollId == toEmployeeIdNew) {
                                    statusRep = SUB_CERTIFICATED_STATUS.PENDING_FOR_ACKNOWLEDGEMENT_SUB_DESK //'Sub Desk';
                                
								} else {
									 
                                    statusRep = SUB_CERTIFICATED_STATUS.PENDING_FOR_ACKNOWLEDGEMENT_SUB_DESK //'Pending for Acknowledgement'
                                }

                            }
                            reportStatus = (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].status == 'CLOSED' ? SUB_CERTIFICATED_STATUS.COMPLETED : (certificatedSubRequestTransactionCycleResponsesForReport[certificatedSubRequestTransactionCycleResponsesForReport.length - 1].status == 'REJECTED' ? SUB_CERTIFICATED_STATUS.REJECTED : (payrollStats) == 'PENDING' ? SUB_CERTIFICATED_STATUS.PENDING : payrollStats === 'OPEN' ? statusRep : payrollStats === 'Reviewed & resubmitted' ? SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN : payrollStats))


                        }

                        if (certificatedSubInitiateRequestResponseForApprover) {
                            //get school name from its id.
                            // var SchoolResponses1 = await DataStore.query(Schools, (c) => c.id.eq(certificatedSubInitiateRequestResponseForApprover.schoolOrDeptId));
                            var SchoolResponses1 = schoolList.find(o => o.id === certificatedSubInitiateRequestResponseForApprover.schoolOrDeptId)

						let archiveDesignation = getArchiveDesignation(certificatedSubInitiateRequestResponseForApprover)
                            //ge number of substitute from CertificatedSubRequestTeacherData table
                            // var certificatedSubRequestTeacherDataResponses1 = await DataStore.query(CertificatedSubRequestTeacherData, (c) => c.reportId.eq(certificatedSubInitiateRequestResponseForApprover.id));
							if (certificatedSubInitiateRequestResponseForApprover?.isArchivedUsers) {
									const archieveData=JSON.parse(certificatedSubInitiateRequestResponseForApprover?.isArchivedUsers);
									//console.log("substituteCertificateRequestResponse?.isArchivedUsers:-",archieveData);
									//console.log("substituteCertificateRequestResponse?.isArchivedUsers 0:-",typeof archieveData);
									let isArchive = CheckArchive(archieveData, archiveDesignation, loggedUserId);
									if(isArchive){
										continue outerLoop;
									}
									
								}
								
                            var certificatedSubRequestTeacherDataResponses1 = certificatedSubRequestTeacherDataList.filter(e => e.reportId.includes(certificatedSubInitiateRequestResponseForApprover.id))

                            if (SchoolResponses1 && certificatedSubRequestTeacherDataResponses1) {
                                let obj = {
                                    reportId: certificatedSubInitiateRequestResponseForApprover.id,
                                    id:certificatedSubInitiateRequestResponseForApprover.id,
									srNo: sn1,
									archiveDesignation:archiveDesignation,
                                    assighnmentTitle: certificatedSubInitiateRequestResponseForApprover.assighmentTitle ? certificatedSubInitiateRequestResponseForApprover.assighmentTitle : "-",
                                    requestDate: moment(certificatedSubInitiateRequestResponseForApprover.reportDate).format('MM/DD/YYYY'),
                                    schoolOrDeptName: SchoolResponses1?.name,
                                    nOfSubstitutes: certificatedSubRequestTeacherDataResponses1.length,
                                    status: reportStatus,
                                    Assignee: reportStatus === "Completed" ? "-" : Assignee,
                                    remark: payrollRemark || '-',
                                    purpose: certificatedSubInitiateRequestResponseForApprover.purposeOfReport,
                                    submittedBy: initiatorFullName,
                                }

                                //console.log(obj.assighnmentTitle,"assighnmentTitle")
                                //console.log(obj.reportId,"assighnmentTitle")
                                sn1 = sn1 - 1
                                finalRequestedRequestData.push(obj);
                            }
                        }
                    }

                    finalRequestedRequestData.reverse();


                    setPayrollReportRequest(finalRequestedRequestData);
                    if (subCer_reportId) {
                        const isMatch = finalRequestedRequestData.filter((data) => data.reportId === subCer_reportId);
                        console.log("isMatch", isMatch)
                        if (isMatch && isMatch[0]?.status === "Pending for Acknowledgement"
                        ) {
                            onClickRequestedReportEditPopUp(isMatch[0])
                            // setSpecificReportDataForEdit(isMatch[0])
                        }
                    }
                    isLoadDataPayrollReport(false);
                }

            }


        } catch (error) {
            console.log("error-->", error)

        }


    }
    const convertArrayOfObjectsToCSV = (data) => {
        const csvRows = [];
        const headers = Object.keys(data[0]);

        csvRows.push(headers.join(','));

        for (const row of data) {
            const values = headers.map((header) => row[header]);
            csvRows.push(values.join(','));
        }

        return csvRows.join('\n');
    };

    const downloadCSV = (data, filename) => {
        const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    };


    const exportFilteredDataToCSVPayroll = (fileName) => {

        // const dataToExport = payrollReportRequest.map(({ srNo, firstApproverId, nOfSubstitutes, createdAt, purpose, reportId, requestDate, schoolOrDeptName, secondApproverId, thirdApproverId }) => ({
        //     "SI No": srNo, "First Approver ID": firstApproverId, "No of Substitutes": nOfSubstitutes, "Purpose": purpose, "Report ID": reportId, "Request Date": requestDate, "School or Department Name": schoolOrDeptName, "Second Approver ID": secondApproverId, "Third Approver ID": thirdApproverId, "Created At": createdAt
        // }));

        const dataToExport = payrollReportRequest.map(({ srNo, assighnmentTitle, requestDate, nOfSubstitutes, createdAt, status, Assignee, remark, schoolOrDeptName, submittedBy, }) => ({
            "SI No": srNo, "Submitted On": requestDate, "Assignment Title": assighnmentTitle, "No of Substitutes": nOfSubstitutes, "Status": status, "Assignee": Assignee, "Remarks": remark, "School/ Department": schoolOrDeptName, "Initiator": submittedBy
        }));

        const csvData = convertArrayOfObjectsToCSV(dataToExport);
        downloadCSV(csvData, fileName);
    };


    const exportFilteredDataToCSVApprover = (fileName) => {

        const dataToExport = approvalReportRequestList.map(({ srNo, assighnmentTitle, requestDate, nOfSubstitutes, createdAt, status, Assignee, remark, schoolOrDeptName, submittedBy, }) => ({
            "SI No": srNo, "Submitted On": requestDate, "Assignment Title": assighnmentTitle, "No of Substitutes": nOfSubstitutes, "Status": status, "Assignee": Assignee, "Remarks": remark, "School/ Department": schoolOrDeptName, "Initiator": submittedBy
        }));

        // const dataToExport = approvalReportRequestList.map(({ srNo, firstApproverId, nOfSubstitutes, createdAt, purpose, reportId, requestDate, schoolOrDeptName, secondApproverId, thirdApproverId }) => ({
        //     "SI No": srNo, "First Approver ID": firstApproverId, "No of Substitutes": nOfSubstitutes, "Purpose": purpose, "Report ID": reportId, "Request Date": requestDate, "School or Department Name": schoolOrDeptName, "Second Approver ID": secondApproverId, "Third Approver ID": thirdApproverId, "Created At": createdAt
        // }));

        const csvData = convertArrayOfObjectsToCSV(dataToExport);
        downloadCSV(csvData, fileName);
    };


    const exportFilteredDataToCSV = (fileName) => {
        // const dataToExport = initiatorReportList.map(({ srNo, firstApproverId, nOfSubstitutes, createdAt, purpose, reportId, requestDate, schoolOrDeptName, secondApproverId, thirdApproverId }) => ({
        //     "SI No": srNo, "First Approver ID": firstApproverId, "No of Substitutes": nOfSubstitutes, "Purpose": purpose, "Report ID": reportId, "Request Date": requestDate, "School or Department Name": schoolOrDeptName, "Second Approver ID": secondApproverId, "Third Approver ID": thirdApproverId, "Created At": createdAt
        // }));


        const dataToExport = initiatorReportList.map(({ srNo, assighnmentTitle, requestDate, nOfSubstitutes, createdAt, status, Assignee, remark, schoolOrDeptName, submittedBy, }) => ({
            "SI No": srNo, "Submitted On": requestDate, "Assignment Title": assighnmentTitle, "No of Substitutes": nOfSubstitutes, "Status": status, "Assignee": Assignee, "Remarks": remark, "School/ Department": schoolOrDeptName, "Initiator": submittedBy
        }));

        const csvData = convertArrayOfObjectsToCSV(dataToExport);
        downloadCSV(csvData, fileName);
    };







    //onSelect particular employye
    const selectedEmployeeFunction = async (e) => {

        //remove specific employee from list
        let newEmpForRM = [];
        for (let i = 0; i < empCodeList.length; i++) {
            if (empCodeList[i].code === e.value.code) {
                continue;
            } else {
                newEmpForRM.push(empCodeList[i]);
            }
        }


        setEmpCodeListForRM(newEmpForRM);

        setSelectedEmployee(e.value);
        //set selected id employee data
        allEmployeeDetails.map((currentItem) => {
            if (currentItem.userId === e.value.code) {
                setSelectedEmployeeDetails(currentItem);

                if (currentItem.userReportingManager) {
                    empCodeList.map((currentItems) => {
                        if (currentItems.code === currentItem.userReportingManager) {
                            setSelectedReportingManagerEmployee(currentItems);
                        }
                    })
                } else {
                    setSelectedReportingManagerEmployee(null);
                }

            }
        })


    }


    const TimeSubmittedOn = rowdata => {
        return rowdata.createdAt !== null ? <span> {moment(rowdata.createdAt).format("MM/DD/YYYY")} </span> : "-";
    };


    const [certificatedSubReqIsInitiator, setCertificatedSubReqIsInitiator] = useState(0);
    const [certificatedSubReqIsApprover, setCertificatedSubReqIsApprover] = useState(0);
    const [certificatedSubReqIsPayroll, setCertificatedSubReqIsPayroll] = useState(0);
    const [certificatedSubReqIsSuperadmin, setCertificatedSubReqIsSuperadmin] = useState(0);

    const checkApplicationAccessibility = () => {
        //six-period
        let certificatedSubReqIsInitiator = reactLocalStorage.get("certificatedSubReqIsInitiator");
        let certificatedSubReqIsApprover = reactLocalStorage.get("certificatedSubReqIsApprover");
        let certificatedSubReqIsPayroll = reactLocalStorage.get("certificatedSubReqIsPayroll");
        let certificatedSubReqIsSuperadmin = reactLocalStorage.get("isSubCertSAdmin");

        setCertificatedSubReqIsInitiator(certificatedSubReqIsInitiator);
        setCertificatedSubReqIsApprover(certificatedSubReqIsApprover);
        setCertificatedSubReqIsPayroll(certificatedSubReqIsPayroll);
        setCertificatedSubReqIsSuperadmin(certificatedSubReqIsSuperadmin)
        if (certificatedSubReqIsInitiator === 1 && certificatedSubReqIsApprover === 1) {
            setActiveIndex(0);
        }
        else if (certificatedSubReqIsInitiator == 1) {
            setActiveIndex(0);
        }
        else if (certificatedSubReqIsApprover == 1) {
            setActiveIndex(1);
        }
        else if (certificatedSubReqIsPayroll == 1) {
            setActiveIndex(2);
        }

        //-----------------------------------------------------
        if (reportIdFromAP) {
            if (certificatedSubReqIsInitiator === 1 && certificatedSubReqIsApprover === 1) {
                setActiveIndex(1);
            }
            else if (certificatedSubReqIsApprover == 1) {
                setActiveIndex(1);
            }
        }
        //-----------------------------------------------------
    };

    const getMasterData = async () => {

        let schoolsArray = await graphQLGetAllData("listSchools")
        setSchoolList(schoolsArray)

        let certificatedSubRequestTransactionData = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles")
        setCertificatedCycleList(certificatedSubRequestTransactionData)

        let certificateSubInitiateReqeustData = await graphQLGetAllData("listCertificatedSubInitiateRequests")
        setCertificatedSubInitiateRequestList(certificateSubInitiateReqeustData)


        let certificatedSubRequestTeacherDataArray = await graphQLGetAllData("listCertificatedSubRequestTeacherData")
        setCertificatedSubRequestTeacherDataList(certificatedSubRequestTeacherDataArray)

        setIsMasterDataLoaded(true)
        setIsUpdateData(Math.random())
    }

    // OLD CODE
    // useEffect(() => {
    //     checkApplicationAccessibility();
    //     loadUsers();
    //     onLoad();
    //     BindList();
    // }, [certificatedSubReqIsPayroll, certificatedSubReqIsInitiator, certificatedSubReqIsApprover]);

    useEffect(() => {
        onLoad();
        checkApplicationAccessibility();
        getMasterData();
    }, []);

    useEffect(() => {


        if (isMasterDataLoaded === true) {
            BindList();
            loadUsers();
        }
    }, [isMasterDataLoaded, isUpdateData]);


    // const [statuses] = useState([
    // 'Completed',
    // 'Pending for Acknowledgement',
    // 'Pending for Budget Clerk',
    // 'Pending for Budget Manager',
    // 'Pending for Dept Head',
    // 'Rejected',
    // ]);

    // const [statusesForPayroll] = useState([
    // 'Completed',
    // 'Pending for Acknowledgement',
    // 'Pending for Budget Clerk',
    // 'Pending for Budget Manager',
    // 'Pending for Dept Head',
    // 'Rejected',
    // ]);

    const [statuses] = useState([
        SUB_CERTIFICATED_STATUS.COMPLETED,
        SUB_CERTIFICATED_STATUS.PENDING_FOR_ACKNOWLEDGEMENT_SUB_DESK,
        SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_CLERK,
        SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_MANAGER,
        SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN,
        SUB_CERTIFICATED_STATUS.PENDING,
        SUB_CERTIFICATED_STATUS.REJECTED,
    ]);

    const [statusesForPayroll] = useState([
        SUB_CERTIFICATED_STATUS.COMPLETED,
        SUB_CERTIFICATED_STATUS.PENDING_FOR_ACKNOWLEDGEMENT_SUB_DESK,
        SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_CLERK,
        SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_BUDGET_MANAGER,
        SUB_CERTIFICATED_STATUS.PENDING_FOR_APPROVAL_SITE_ADMIN,
        SUB_CERTIFICATED_STATUS.PENDING,
        SUB_CERTIFICATED_STATUS.REJECTED,
    ]);

    const statusItemTemplate = (option) => {

        return <Tag value={option} severity={TaskStatusSL(option)} />;
    };

    const statusRowFilterTemplate = (options) => {
        return (
            <div className='dropclass'>
                <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown " showClear style={{ minWidth: '7rem' }} />
            </div>
        );
    };

    const statusRowFilterTemplatePayroll = (options) => {
        return (
            <Dropdown value={options.value} options={statusesForPayroll} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown statusFilter" showClear style={{ minWidth: '7rem' }} />
        );
    };

    const sideDrawerClosedHandler = () => {
        setViewPopup(false);
        setVisibleRequestedReportEdit(false);
        // Unsets Background Scrolling to use when SideDrawer/Modal is closed
        document.body.style.overflow = 'unset';
    }

    return isAuthenticated ? (
        <>
            <Layout pageTitle="Report" activeMenu="Initiator" appId='SUBSTITUTE_REQUEST_CERTIFICATED' reDirectUrl={"/substitute_request_certificated"}
                IsArchive={true}
                reDirectUrlforSA={"/substitute_request_certificated/SuperAdminDashboard"}
                IsSuperadmin={certificatedSubReqIsSuperadmin}
                reDirectUrlforArchive={"/substitute_request_certificated/ArchiveReport"}

            // IsSuperadmin={true}
            >
                <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
                    <div className="flex justify-end visible lg:hidden">
                        <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                        {/* <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-3">
                            <div>
                                <div id={activate} className="bg-[#FFFFFF] rounded-lg box-shadow-1 radius4 p-4 xl:p-[0.833vw] top-5 lg:sticky fixed -left-96 lg:left-0 lg:overflow-hidden lg:h-auto z-10" data-aos="fade-up" data-aos-duration="800">
                                    <div className="flex justify-between text-[#101828] font-medium text-base tracking-[0.02em] xl:text-[0.932vw]">
                                        <p>Forms</p>
                                        <div className="xl:w-[10.058vw] md:w-[200px] custinput">
                                            <span className="w-full p-input-icon-left">
                                                <i className="gusd-search text-[#667085] mt-0" />
                                                <InputText placeholder="Search" className="w-full" />
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mt-4 h-[600px] xl:h-[38vw]  overflow-auto">

                                        <div className="bg-[#0F1E4C]  radius4 p-[16px] xl:p-[0.833vw]">
                                            <h6 className="font-medium text-[16px] text-[#fff] xl:text-[0.833vw] mb-2">Certificated Substitute Requests</h6>
                                            <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                                <div className="flex items-center gap-1">
                                                    <div className="bg-[#EAEFFF] text-[16px] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                        {(activeIndex === 0) ? submitCount : pendingForApprovalCountForReqReportsCount}
                                                    </div>
                                                    <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">{(activeIndex === 0) ? 'Submitted' : 'Pending For Approvals'}</div>
                                                </div>
                                                <div className="flex items-center gap-1">
                                                    <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                        {(activeIndex === 0) ? approvedCount : approvedCountForReqReportsCount}
                                                    </div>
                                                    <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Approved </div>
                                                </div>
                                                <div className="flex items-center gap-1">
                                                    <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                        {(activeIndex === 0) ? rejectCount : rejectCountForReqReportsCount}
                                                    </div>
                                                    <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Rejected</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="relative z-10 col-span-12 lg:col-span-12" data-aos="fade-down" data-aos-duration="800">
                            <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                                <div className="flex flex-col md:flex-row  items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                                    <p className="text-[22px] xl:text-[0.938vw]  text-[#101828] font-medium mb-[15px] md:mb-[0px]">Substitute Request Certificated</p>
                                    <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                                        {
                                            activeIndex === 0 && userloggedRole !== USER_TYPES_NAMES.P ?

                                                <Link to='/substitute_request_certificated/initiate_new_report' className="w-full text-center tableBtn blue radius8">
                                                    <i className="gusd-pluse-circle mx-1.5 ml-5px"></i> Initiate New Report</Link>
                                                : null
                                        }
                                        {/* {certificatedSubReqIsApprover === 1 ? <Link to="#" onClick={() => { exportFilteredDataToCSVApprover("CertificatedSubReqApprover.csv") }} className=" " > <i className="pi pi-download "></i></Link>
                                            : <Link to="#" onClick={() => { exportFilteredDataToCSV("CertificatedSubReqInitiator.csv") }} className=" " > <i className="pi pi-download "></i></Link>} */}

                                        {certificatedSubReqIsInitiator != 1 && certificatedSubReqIsPayroll != 1 ? <Link to="#" onClick={() => { exportFilteredDataToCSVApprover("SubstituteRequestCerificatedApprover.csv") }} className=" " > <i className="pi pi-download "></i></Link>
                                            : certificatedSubReqIsPayroll == 1 ? <Link to="#" onClick={() => { exportFilteredDataToCSVPayroll("SubstituteRequestCertificatedSubdesk.csv") }} className=" " > <i className="pi pi-download "></i></Link>
                                                : <Link to="#" onClick={() => { exportFilteredDataToCSV("SubstituteRequestCertificatedInitiator.csv") }} className=" " > <i className="pi pi-download "></i></Link>}
                                    </div>
                                </div>


                                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                                    {
                                        (certificatedSubReqIsInitiator == 1) ?
                                            <TabPanel header="Initiate Reports">


                                                <div className={initiatorReportList.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow checkbox-Border"}>
                                                    <DataTable
                                                        className="custpaginator custIcons custmBtnTable custTable statusFilter  "
                                                        scrollable
                                                        sortOrder="-1"
                                                        sortField="createdAt"
                                                        loading={isLoadData}
                                                        value={initiatorReportList}
                                                        paginator rowsPerPageOptions={[10, 20, 30]} filters={filters} filterDisplay="row" responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={10}
                                                        selectionMode="multiple"  // Corrected attribute name
                                                        selection={selectedRows}
                                                        emptyMessage="No customers found."
                                                    >

                                                        <Column
                                                            style={{ minWidth: "3rem" }}
                                                            header={<CheckboxHeader
                                                                queries={queries.getCertificatedSubInitiateRequest}
                                                                tableName={"getCertificatedSubInitiateRequest"}
                                                                mutations={mutations.updateCertificatedSubInitiateRequest}
                                                                data={initiatorReportList}
                                                                setReportLoading={setIsLoadData}
                                                                selectedRows={selectedRows} setSelectedRows={setSelectedRows} getMasterData={() => getMasterData()}
															loggedUserId={loggedUserId} 
                                                            />}
                                                            body={(rowData) => <CheckboxColumn data={rowData}
                                                                selectedRows={selectedRows}
                                                                setSelectedRows={setSelectedRows} />}
                                                        />

                                                        <Column header="SL#" body={CounterAction} style={{ minWidth: '3rem' }}></Column>
                                                        <Column field="createdAt" header="Submitted On" filter filterPlaceholder="Search" body={TimeSubmittedOn} sortable style={{ minWidth: '5rem' }}></Column>
                                                        {/* <Column field="schoolOrDeptName" header="School or Department Name" filter filterPlaceholder="Search" sortable></Column> */}
                                                        <Column field="assighnmentTitle" header="Assignment title" filter filterPlaceholder="Search" sortable></Column>
                                                        <Column field="nOfSubstitutes" header="No of Substitutes" filter filterPlaceholder="Search" sortable></Column>
                                                        <Column header="Status" field="status" filter filterElement={statusRowFilterTemplate} body={TaskStatusSLA} sortable style={{ minWidth: '8rem' }}></Column>
                                                        <Column field="Assignee" header="Assignee" filter filterPlaceholder="Search" sortable></Column>
                                                        <Column field="remark" header="Remarks" align='center' style={{ minWidth: '6rem' }}></Column>
                                                        <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={initiateReportAction} style={{ minWidth: '10rem' }}></Column>

                                                    </DataTable>
                                                </div> 
                                            </TabPanel> : null
                                    }

                                    {
                                        (certificatedSubReqIsApprover == 1) ?
                                            <TabPanel header="Requested Reports">

                                                        <div className={approvalReportRequestList.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
                                                            <DataTable className="custpaginator custIcons custmBtnTable custTable" scrollable
                                                                value={approvalReportRequestList}
                                                                paginator rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" filters={filters} filterDisplay="row" sortOrder="-1" sortField="createdAt" 
                                                                loading={loadDataReqReport}
                                                                paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}
																selectionMode="multiple"  // Corrected attribute name
                                                        
                                                            // selectionMode='checkbox' selection={selectedReports} onSelectionChange={(e) => setSelectedReports(e.value)} dataKey="srNo"
                                                            >
															
															<Column
                                                            style={{ minWidth: "3rem" }}
                                                            header={<CheckboxHeader
                                                                queries={queries.getCertificatedSubInitiateRequest}
                                                                tableName={"getCertificatedSubInitiateRequest"}
                                                                mutations={mutations.updateCertificatedSubInitiateRequest}
                                                                data={approvalReportRequestList}
                                                                setReportLoading={isLoadDataReqReport}
                                                                selectedRows={selectedRowsApp} setSelectedRows={setSelectedRowsApp} getMasterData={() => getMasterData()}
															loggedUserId={loggedUserId} 
                                                            />}
                                                            body={(rowData) => <CheckboxColumn data={rowData}
                                                                selectedRows={selectedRowsApp}
                                                                setSelectedRows={setSelectedRowsApp} />}
                                                        />
														
                                                                <Column body={CounterAction} header="SL#" style={{ minWidth: '3rem' }}></Column>
                                                                <Column field="createdAt" header="Submitted On" filter filterPlaceholder="Search" body={TimeSubmittedOn} sortable style={{ minWidth: '5rem' }} ></Column>
                                                                {/* <Column field="schoolOrDeptName" header="School or Department Name" filter filterPlaceholder="Search" sortable></Column> */}
                                                                <Column field="assighnmentTitle" header="Assignment title" filter filterPlaceholder="Search" sortable></Column>
                                                                <Column field="nOfSubstitutes" header="No of Substitutes" filter filterPlaceholder="Search" sortable></Column>
                                                                {/* <Column field="Status" header="Status" filter filterElement={statusRowFilterTemplateApp} body={requestReportStatus} sortable style={{ minWidth: '8rem' }}></Column> */}
                                                                <Column header="Status" field="status" filter filterElement={statusRowFilterTemplate} body={requestReportStatus} sortable style={{ minWidth: '8rem' }}></Column>
                                                                <Column field="Assignee" header="Assignee" filter filterPlaceholder="Search" sortable></Column>
                                                                <Column field="remark" header="Remarks" style={{ minWidth: '5rem' }}></Column>
                                                                <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={requestedReportAction} style={{ minWidth: '6rem' }}></Column>
                                                            </DataTable>
                                                        </div> 
                                            </TabPanel> : null
                                    }

                                    {
                                        (certificatedSubReqIsPayroll == 1) ?
                                            <TabPanel header="Payroll Reports">

                                                        <div className={payrollReportRequest.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
                                                            <DataTable className="custpaginator custIcons custmBtnTable custTable" scrollable
                                                                value={payrollReportRequest}
                                                                paginator rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" filters={filters} filterDisplay="row" sortOrder="-1" sortField="submittedOn" 
                                                                loading={loadDataPayrollReport}
																selectionMode="multiple"  // Corrected attribute name
                                                       
                                                                paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}
                                                            >
															
															<Column
                                                            style={{ minWidth: "3rem" }}
                                                            header={<CheckboxHeader
                                                                queries={queries.getCertificatedSubInitiateRequest}
                                                                tableName={"getCertificatedSubInitiateRequest"}
                                                                mutations={mutations.updateCertificatedSubInitiateRequest}
                                                                data={payrollReportRequest}
                                                                setReportLoading={isLoadDataPayrollReport}
                                                                selectedRows={selectedRowsPay} setSelectedRows={setSelectedRowsPay} getMasterData={() => getMasterData()}
															loggedUserId={loggedUserId} 
                                                            />}
                                                            body={(rowData) => <CheckboxColumn data={rowData}
                                                                selectedRows={selectedRowsPay}
                                                                setSelectedRows={setSelectedRowsPay} />}
                                                        />
														
                                                                <Column body={CounterAction} header="SL#" style={{ minWidth: '3rem' }}></Column>
                                                                <Column field="requestDate" header="Submitted On" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }} ></Column>
                                                                <Column field="assighnmentTitle" header="Assignment title" filter filterPlaceholder="Search" sortable></Column>
                                                                <Column field="nOfSubstitutes" header="No of Substitutes" filter filterPlaceholder="Search" sortable></Column>
                                                                <Column header="Status" field="status" filter filterElement={statusRowFilterTemplatePayroll} body={TaskStatusSLA} sortable style={{ minWidth: '8rem' }}></Column>
                                                                <Column field="Assignee" header="Assignee" filter filterPlaceholder="Search" sortable></Column>
                                                                <Column field="remark" header="Remarks" style={{ minWidth: '5rem' }}></Column>
                                                                <Column field="action" header="Action" frozen alignFrozen="right" align='center' body={payrollReportAction} style={{ minWidth: '6rem' }}></Column>
                                                            </DataTable>
                                                        </div> 
                                            </TabPanel> : null
                                    }

                                </TabView>


                                {/* PopUps:View Popup */}
                                <ViewPopUp
                                    viewPopUp={viewPopUp}
                                    closePopUp={() => { setViewPopup(false); sideDrawerClosedHandler(); }}
                                    specificReportDataForView={specificReportDataForView}
                                />
                                {/* PopUps:Requested Report Edit Popup */}
                                <EditPopupRequestedReport
                                    visibleRequestedReportEdit={visibleRequestedReportEdit}
                                    closePopUp={() => { sideDrawerClosedHandler(); }}
                                    specificReportDataForEdit={specificReportDataForEdit}
                                    certificatedSubReqIsPayroll={certificatedSubReqIsPayroll}
                                    BindList={() => BindList()}
                                    getMasterData={() => getMasterData()}
                                    showEditReportButton={showEditReportButton}
                                />

                                {/* confirmation dialog */}
                                <Dialog header="" visible={confirmVisible} style={{ width: '30vw' }} onHide={() => { setConfirmVisible(false); setVisibleEdit(false); }} footer={footerContent}>
                                    <p className="m-0 text-[#0487C8]">
                                        <i className='pi pi-check-circle mr-2'></i>
                                        <span className='font-medium text-[18px]'>Your changes has been saved in this report</span>
                                    </p>
                                </Dialog>
                                {/* edit popup end */}



                                <Dialog header="" visible={requestApprovalConfirmVisible} style={{ width: '30vw' }} onHide={() => { setRequestApprovalConfirmVisible(false); setVisibleEdit(false); }} footer={footerContentForReqApproval}>
                                    <p className="m-0 text-[#0487C8] text-center">
                                        <i className='pi pi-check-circle mr-2'></i>
                                        <span className='font-medium text-[18px]'>This report was Approved</span>
                                    </p>
                                </Dialog>

                                {/* edit popup end */}
                                {/* edit popup for requested report end */}
                                {/* for reminder notification */}
                                <Dialog
                                    header="Reminder"
                                    visible={ReminderDialog}
                                    style={{ width: "30vw" }}
                                    onHide={() => {
                                        setreminderDialog(false);
                                    }}
                                    closable={false}
                                    footer={footerContentForReminder}
                                >
                                    <p className="m-0 text-[#0487C8] text-center">
                                        <i className="mr-2 pi pi-check-circle"></i>
                                        <span className="font-medium text-[18px]">{`By clicking Yes, a reminder will be sent to ${ReminderData?.Assignee} to approve the form. Click No to cancel.`}</span>
                                    </p>
                                </Dialog>
                                {/* for reminder notification */}
                            </div>

                            <Sidebar visible={visibleRight} position="right" onHide={() =>
                                setVisibleRight(false)} style={{ width: '35vw' }} className="customesidebar1 responsivepoup">
                                <Editpopup popupstate={() => setVisibleRight(false)}
                                    fromDate={fromDate}
                                    toDate={toDate}
                                    schoolName={schoolName}
                                    reportEmployeeList={reportEmployeeList}
                                    status={status}
                                    reportId={reportId}
                                    // bindList={() => loadAbsenceReport()}
                                    type={"Initior"}
                                />

                            </Sidebar>
                        </div>
                    </div>
                </div >


                {/* popup's */}
                < Dialog className="relative reports-popup" visible={visibleCreteReportPopup} position="right" style={{ width: '30vw' }
                } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleCreteReportPopup(false)} draggable={false} resizable={false} >
                    <div className="">
                        <div className="bg-[#F5F6F7] relative h-screen">
                            <div className="p-5">
                                <a to='' onClick={() => setVisibleCreteReportPopup(false)} className="py-3"><Image
                                    src={sidebar} alt="user" width="24" height="24" /></a>
                                <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">6th Period Teaching Assignment</div>
                                {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div> */}
                                <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                    <div className="mb-1">
                                        <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Assignment Title</label>
                                        <div><InputText
                                            value={groupName}
                                            onChange={e => setGroupName(e.target.value)}
                                            id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                                <Link to='#' className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center" onClick={() => setVisibleCreteReportPopup(false)}><i className="pi pi-times mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>

                                <Link to='' className=" text-center flex items-center tableBtn blue radius8" onClick={() => {
                                    setShowNextPopUp(true);
                                    // saveGroupInfo();
                                }}><i className="pi pi-arrow-right mr-1" style={{ fontSize: '1rem' }}></i>Next</Link>

                            </div>
                        </div>
                    </div>
                </Dialog >

                {
                    (isVisibleDelete) ?
                        <ReportDeleteDialog
                            isVisibleDelete={isVisibleDelete}
                            setIsVisibleDelete={setIsVisibleDelete}
                            isVisibleDeleteID={isVisibleDeleteID}
                            getMasterData={() => getMasterData()}
                            setIsLoadData={() => setIsLoadData(true)}
                            queries={queries.getCertificatedSubInitiateRequest}
                            tableName={"getCertificatedSubInitiateRequest"}
                            mutations={mutations.updateCertificatedSubInitiateRequest}

                        /> : null
                }

            </Layout >
        </>
    ) : (
        <Login sessionExpired={1} />
    );
}